import { Link, useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import "@/styles/board.css";

const ITEMS = [
  { to: "/admin", label: "Admin home", badge: false },
  { to: "/admin/membership", label: "Membership", badge: true },
  { to: "/admin/corrections", label: "Corrections", badge: false },
  { to: "/admin/traffic", label: "Profile traffic", badge: false },
  { to: "/admin/invites", label: "Availability invites", badge: false },
  { to: "/admin/tiles", label: "CPD studio", badge: false },
  { to: "/admin/brief", label: "Referral brief", badge: false },
  { to: "/admin/access-report", label: "Access Report", badge: false },
  { to: "/admin/rounds", label: "Rounds", badge: false },
] as const;

export function AdminNav() {
  const { pathname } = useLocation();
  const membership = useQuery({
    queryKey: ["admin-membership", "new"],
    queryFn: () => api.get<{ items: unknown[]; total: number }>("/v1/admin/membership", { params: { status: "new" } }),
    staleTime: 30_000,
  });
  return (
    <nav className="pb-admin-nav" aria-label="Admin areas">
      {ITEMS.map((item) => (
        <Link key={item.to} to={item.to} aria-current={pathname === item.to ? "page" : undefined}>
          {item.label}
          {item.badge && membership.data?.total ? (
            <span className="pb-admin-nav-badge" aria-label={`${membership.data.total} new membership requests`}>
              {membership.data.total}
            </span>
          ) : null}
        </Link>
      ))}
    </nav>
  );
}
